import { LegalAgreement, LegalDocuments, LegalDocumentType } from '@innovation-os-ng/core/models';

export abstract class LegalContractService {
  /**
   * Returns contract document detail
   */
  public abstract getContractDocuments(language: string): Promise<Array<LegalDocuments>>;

  /**
   * Returns contract for tenant
   */
  public abstract getContractsForTenant(tenantUri: string, language: string): Promise<Array<LegalDocuments>>;

  /**
   * Saves an agreement to global contract
   */
  public abstract saveAgreementToGlobalContract(language: string, version: string, type: string): Promise<LegalAgreement>;

  /**
   * Returns pending global contracts
   */
  public abstract getPendingGlobalContracts(language?: string, type?: string, userContractsOnly?: boolean): Promise<Array<LegalDocuments>>;

  /**
   * Saves Contract for tenant
   */
  public abstract saveContractForTenant(tenantUri: string, contract: Partial<LegalDocuments>): Promise<Array<LegalDocuments>>;

  /**
   * Returns Pending agreements for tenant contract
   */
  public abstract getPendingAgreementsForTenantContracts(
    tenantUri: string,
    type?: LegalDocumentType,
    language?: string
  ): Promise<Array<LegalDocuments>>;

  /**
   * Returns Pending agreements for tenant contract providing tenantSlug
   */
  public abstract getPendingAgreementsForTenantContractsByTenantSlug(
    tenantSlug: string,
    type?: LegalDocumentType,
    language?: string
  ): Promise<Array<LegalDocuments>>;

  /**
   * Saves an agreement for tenant
   */
  public abstract saveAnAgreementForTenant(tenantUri: string, contract: Partial<LegalDocuments>): Promise<Array<LegalAgreement>>;
}
